import * as constants from './constants'

export const getRates = ({ grsId, preselectedRateId, waitingListKey, extendingStart, extendingEnd, isExtending }) => ({
    type: constants.GET_RATES,
    grsId,
    preselectedRateId,
    waitingListKey,
    extendingStart,
    extendingEnd,
    isExtending,
})

export const setRates = rates => ({
    type: constants.SET_RATES,
    rates,
})

export const selectRate = selectedRateId => ({
    type: constants.SELECT_RATE,
    selectedRateId,
})

export const clearSelectedRate = () => ({
    type: constants.CLEAR_SELECTED_RATE,
})

export const setSelectedRateDetails = details => ({
    type: constants.SET_SELECTED_RATE_DETAILS,
    details,
})

export const selectCreditCard = card => ({
    type: constants.SET_SELECTED_CREDIT_CARD,
    card,
})

export const selectVehicle = selectedVehicles => ({
    type: constants.SET_SELECTED_VEHICLE,
    selectedVehicles,
})

export const removeFromSelectedVehicles = vehicle => ({
    type: constants.REMOVE_FROM_SELECTED_VEHICLES,
    vehicle,
})

export const setLastBookingDetails = ({ grsId, rateId, subscriptions, waitingListKey, rate, id }) => ({
    type: constants.SET_LAST_BOOKING_DETAILS,
    grsId,
    rateId,
    subscriptions,
    waitingListKey,
    rate,
    id,
})

export const clearLastBookingDetails = () => ({
    type: constants.CLEAR_LAST_BOOKING_DETAILS,
})

export const getBookingLocationDetails = grsId => ({
    type: constants.GET_BOOKING_LOCATION_DETAILS,
    grsId,
})

export const setBookingLocationDetails = locationDetails => ({
    type: constants.SET_BOOKING_LOCATION_DETAILS,
    locationDetails,
})

export const setRawPromoCode = value => ({
    type: constants.SET_RAW_PROMO_CODE,
    value,
})

export const lastBookingRedeemPromoCode = item => ({
    type: constants.LAST_BOOKING_REDEEM_PROMO_CODE,
    item,
})

export const lastBookingRedeemedPromoCode = promoCode => ({
    type: constants.LAST_BOOKING_REDEEMED_PROMO_CODE,
    promoCode,
})

export const lastBookingRemovePromoCode = item => ({
    type: constants.LAST_BOOKING_REMOVE_PROMO_CODE,
    item,
})

export const enableCard = cards => ({
    type: constants.ENABLE_CARD,
    cards,
})

export const exitBookingFlow = () => ({
    type: constants.EXIT_BOOKING_FLOW,
})

export const selectSeasonTicket = (ticket, grsId, startDate, waitingListKey) => ({
    type: constants.SELECT_SEASON_TICKET,
    ticket,
    grsId,
    startDate,
    waitingListKey,
})

export const receivedSelectedSeasonTicketRate = rate => ({
    type: constants.RECEIVED_SELECTED_SEASON_TICKET_RATE,
    rate,
})

export const setParkingMode = searchMode => ({
    type: constants.SET_PARKING_MODE,
    searchMode,
})

export const receivedWaitingListRate = rate => ({
    type: constants.RECEIVED_WAITING_LIST_RATE,
    rate,
})

export const lastBookingSetAutoRenew = autoRenew => ({
    type: constants.LAST_BOOKING_SET_AUTO_RENEW,
    autoRenew,
})
